export enum OperationResultType {
  Ok = "Ok",
  Warning = "Warning",
  Error = "Error",
}
